import axios from '../../../../utils/request';

function GET_LIST(params) {
    return axios.post("/statistics/Rank/version",{ ...params
    } )
}
function EXPORT(params) {
    return  axios.post("/statistics/Rank/versionExport",{...params
    }  )
}

export default {
    GET_LIST,
    EXPORT,
};
